import { createContext, Dispatch, SetStateAction } from "react"

import { IconProps } from "../../components/typography"

export type ToastAnchorHorizontal = "left" | "center" | "right"

export type ToastState = null | {
	message: string
	action?: ToastAction
	iconName?: IconProps["icon"]
	iconFamily?: IconProps["family"]
	iconColor?: IconProps["color"]
	variant?: "default" | "light"
	anchorHorizontal?: ToastAnchorHorizontal
}

export interface ToastAction {
	actionText: string
	actionOnClick: () => void
	actionIcon?: IconProps["icon"]
}

export const ToastContext = createContext<
	[ToastState, Dispatch<SetStateAction<ToastState>>] | undefined
>(undefined)
